module.exports = __webpack_public_path__ + "img/sept_event_banner.0611c28e.png";